import { styled } from '@mui/material/styles';

export const NavigationRoot = styled('div')(({ theme }) => ({
    display: 'flex',
    gap: '1rem',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 0.5rem',
    background: theme.palette._components.navigation.topNavBackground,
    color: theme.palette.primary.contrastText,
    position: 'fixed',
    top: 0,
    width: '100vw',
    zIndex: 999,
    height: 'var(--header__height--large)',

    [theme.breakpoints.down('sm')]: {
        gap: 0,
        '&:has(.topNavMiddleAdornment:focus-within)': {
            '.left-section': {
                display: 'none',
            },
            '.user-navigation': {
                display: 'none',
            },
            '.topNavMiddleAdornment': {
                flexGrow: 1,
            },
        },
    },
}));

export const LeftSection = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    [theme.breakpoints.down('sm')]: {
        gap: 0,
    },
}));

export const LogoIconWrapper = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
        display: 'none',
    },
}));

export const LogoTextWrapper = styled('div')(({ theme }) => ({
    fontWeight: 600,
    marginLeft: '0.5rem',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
        display: 'none',
    },
}));

export const StyledDrawerPaper = styled('div')(({ theme }) => ({
    backgroundColor: `${theme.palette._components.navigation.backgroundColor} !important`,
    color: `${theme.palette.primary.contrastText} !important`,
    minWidth: 300,
    scrollbarWidth: 'thin',
    scrollbarColor: theme.palette._components.navigation.scrollbarColor,
}));

export const StyledNavMiddleAdornment = styled('div')(({ theme, hideTopNav }) => ({
    display: 'contents',
    [theme.breakpoints.down('sm')]: {
        '& .MuiFormControl-root': {
            flexGrow: 1,
        },
    },
    ...(hideTopNav && {
        display: 'none',
    }),
}));
